/** @format */

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
export function isObject(variable: any) {
    return (
        typeof variable === 'object' &&
        variable !== null &&
        !Array.isArray(variable)
    );
}

export function isRecordLike(
    isRecordLike: unknown
): isRecordLike is Record<string, unknown> {
    return isObject(isRecordLike);
}
